import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import VueI18n from "vue-i18n";
// import "element-ui/lib/theme-chalk/index.css";
import "./styles/element-variables.scss"
// 引入语言资源文件
import en from "../public/lang/en.js";
import zh from "../public/lang/zh.js";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import enLocale from "element-ui/lib/locale/lang/en";
import "./assets/iconfont/icon/iconfont.css"; //引入阿里巴巴矢量图标库
import "./assets/iconfont/icon/iconfont.js";
import EChartsVue from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
Vue.component("v-chart", EChartsVue);
//默认点击空白处不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false;

window.ElementUI = ElementUI;


import animated from "animate.css";
Vue.use(animated);
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.lang || "zh", // 默认语言为中文
  messages: {
    zh: { ...zh, ...zhLocale },
    en: { ...en, ...enLocale },
  },
  silentTranslationWarn: true, //禁止警告
});
Vue.use(ElementUI, {
  size: "small",
  i18n: (key, value) => i18n.t(key, value),
});
import axios from "axios";
Vue.prototype.axios = axios;

Vue.config.productionTip = false;

// 权限按钮配置
import permission from "@/directive/permission";
Vue.directive("permission", permission);
// dataV
import dataV from "@jiaminghi/data-view";
Vue.use(dataV);

//  es6 => es5

import "babel-polyfill";
import Es6Promise from "es6-promise";
require("es6-promise").polyfill();
Es6Promise.polyfill();

// 引入echarts
import * as echarts from "echarts";
import "echarts/theme/macarons.js";
Vue.prototype.$echarts = echarts;
import Pdfh5 from "pdfh5";
Vue.prototype.$Pdfh5 = Pdfh5;

import china from "echarts/map/json/china.json";
echarts.registerMap("china", china);
import "echarts-wordcloud/dist/echarts-wordcloud.min.js";

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

import htmlToPdf from "./components/utils/htmlToPdf";
Vue.use(htmlToPdf);

import { format } from "@/tools/tool";

import myplugin from "@/plugin/copyVuex";

// import '@/tools/init.js'

// 路由传参加密
const UrlEncode = {
  // //加密
  // encode(str) {
  //   return btoa(
  //     encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(
  //       match,
  //       p1
  //     ) {
  //       return String.fromCharCode("0x" + p1);
  //     })
  //   );
  // },
  // //解密
  // decode(str) {
  //   // Going backwards: from bytestream, to percent-encoding, to original string.
  //   return decodeURIComponent(
  //     atob(str)
  //       .split("")
  //       .map(function (c) {
  //         return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  //       })
  //       .join("")
  //   );
  // },
  encode(str) {
    // 对字符串进行编码
    var encode = encodeURI(str);
    // 对编码的字符串转化base64
    var base64 = btoa(encode);
    return base64;
  },
  decode(base64) {
    // 对base64转编码
    var decode = atob(base64);
    // 编码转字符串
    var str = decodeURI(decode);
    return str;
  },
};
Vue.prototype.$UrlEncode = UrlEncode;

Vue.use(myplugin);
Date.prototype.format = format;
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
